import "dm-file-uploader";
import "selectric";
import helpers from "../utils/helpers";

let recaptchaID = null;

window.applicationOnloadCallback = function () {
  recaptchaID = grecaptcha.render("application-recaptcha", {
    sitekey: recaptcha_key,
    size: "invisible",
    badge: "inline",
    callback: application.challange,
  });
};

const application = {
  init: function () {
    $(".application__form").submit(function (e) {
      e.preventDefault();
      $(".error", this).removeClass("error");

      $(".form__errors").html("");

      if (helpers.validate($(this))) {
        grecaptcha.execute(recaptchaID);
      } else {
        $("html, body").animate(
          {
            scrollTop: $(".application__form").offset().top - 200,
          },
          300
        );
      }
    });

    application.events();
    application.uploader();
    application.sendForm();
    // application.changeSubject();
  },

  changeSubject: function () {
    $("#applicationType").on("change", function () {
      // console.log($(this).val());
    });
  },

  challange: function (token) {
    console.log("Challange");
    if (token) {
      application.submit(token);
    }
    window.grecaptcha.reset();
  },

  events: function () {
    $("select").selectric({
      onChange: function (element) {
        var form = $(".application__form");

        $.ajax({
          url: ajaxurl,
          type: "POST",
          data: {
            action: "change_subject",
            subject: $(element).val(),
            type: $(element).attr("id"),
            pageid: $('[name="pageid"]').val(),
          },
          beforeSend: function () {
            form
              .attr("data-value", form.attr("value"))
              .val("...")
              .addClass("loading");
          },
          success: function (response) {
            form.attr("value", form.attr("data-value")).removeClass("loading");

            var html = JSON.parse(response);
            $('select[name="' + html.result + '"]').empty();

            if (html.result == "application_type_sub") {
              $('select[name="application_type_sub_sub"]').empty();
            }

            var item;
            for (item in html) {
              $('select[name="' + html.result + '"]').append(html[item]);
            }

            $("select").selectric("refresh");
            $("select").each(function () {
              if ($(this).children().length > 1) {
                $(this).parent().parent().removeClass("selectric-hidden");
              } else {
                $(this).parent().parent().addClass("selectric-hidden");
              }
            });
          },
        });

        $(element).closest(".select").removeClass("error");
      },
    });

    $('input[type="checkbox"]').change(function () {
      $(this).removeClass("error");
    });
  },

  submit: function (token) {
    var form = $(".application__form");
    $(".error", form).removeClass("error");

    var subject = $('[name="application_type"]').val();

    var subject_input = $('[name="application_type_sub"]').val();
    if (subject_input) {
      subject += " , " + subject_input;
    }

    var sub_subject_input = $('[name="application_type_sub_sub"]').val();
    if (sub_subject_input) {
      subject += " , " + sub_subject_input;
    }

    var form_data = {
      full_name: $('[name="full-name"]').val(),
      company: $('[name="company"]').val(),
      phone: $('[name="phone"]').val(),
      email: $('[name="email"]').val(),
      message: $('[name="message"]').val(),
      subject: subject,
    };

    $.ajax({
      url: ajaxurl,
      type: "POST",
      extFilter: ["jpg", "jpeg", "png", "pdf"],
      data: {
        action: "send_application_form",
        files: application.getFilesList(),
        form_data: form_data,
        token: token,
        pageid: $('[name="pageid"]').val(),
        honey: $('[name="honey"]').val(),
        nonce: $('[name="nonce"]').val(),
      },
      beforeSend: function () {
        form
          .attr("data-value", form.attr("value"))
          .val("...")
          .addClass("loading");
      },
      success: function (response) {
        form.attr("value", form.attr("data-value")).removeClass("loading");
        $(".form__message", form).removeClass("active");

        if (response.success) {
          form[0].reset();
          grecaptcha.reset();

          $(".input-row", form).removeClass("active");
          $(".form__message--success", form).addClass("active");
          $(".form_file.done").remove();
          $("select").val("");
          $("select").trigger("change");
          $("select").selectric("refresh");
        } else {
          $(".form__message--error", form).addClass("active");
        }
      },
    });
  },

  uploader: function () {
    $(".form__files").on("click", ".js-remove", function () {
      var that = $(this).closest(".form__file");

      $.ajax({
        url: "../../themes/base/lib/upload-remove.php",
        type: "POST",
        data: {
          file: that.data("file"),
        },
      }).done(function (response) {
        if (response) {
          that.remove();
        }
      });
    });
    if ($(".dm-uploader").length) {
      $(".dm-uploader").each(function () {
        var that = $(this).closest(".form__files");

        $(this).dmUploader({
          url: "../../themes/base/lib/upload.php",
          maxFileSize: 3000000, // 3 Megs max
          auto: true,
          queue: false,
          extFilter: ["jpg", "jpeg", "png", "pdf"],
          onDragEnter: function () {
            // Happens when dragging something over the DnD area
            this.addClass("active");
          },
          onDragLeave: function () {
            // Happens when dragging something OUT of the DnD area
            this.removeClass("active");
          },
          onNewFile: function (id, file) {
            var cloned = $(".form__file--clone-base", that).clone();
            cloned.attr("data-id", id).removeClass("form__file--clone-base");
            $(".form__file__name", cloned).text(file.name);
            cloned.appendTo($(".form__file__list", that));
          },
          onUploadProgress: function (id, percent) {
            // Updating file progress
            $('[data-id="' + id + '"] .progress-bar')
              .text(percent + "%")
              .css({ width: percent + "%" });
          },
          onUploadSuccess: function (id, data) {
            // A file was successfully uploaded
            $('[data-id="' + id + '"]')
              .addClass("done")
              .data("file", data.path);
          },
        });
      });
    }
  },

  getFilesList: function () {
    var files = {};
    $(".form__file.done").each(function (index, element) {
      files[index] = $(this).data("file");
    });
    return files;
  },

  sendForm: function () {
    $(
      ".application__form .js-send-another, .application__form .js-retry"
    ).click(function (e) {
      e.preventDefault();
      $(".application__form .form__message").removeClass("active");
    });
  },
};

export default application;
